module.exports = __webpack_public_path__ + "img/features_scoremaster_phone_mobile3.0bb66a3e.jpg";